<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <div class="range-field-container">
            <span class="range-label" *ngIf="field.label">{{ field.label | translate }}</span>
            <div class="range-slider-container">
                <mat-slider
                    [id]="field.id"
                    [attr.formcontrolname]="field.name"
                    [formControl]="control"
                    [min]="field.min || 0"
                    [max]="field.max || 100"
                    [step]="field.step || 1"
                    [thumbLabel]="field.thumbLabel || false"
                    [vertical]="field.vertical || false"
                    [tickInterval]="field.tickInterval || 'auto'"
                    [displayWith]="field.displayWith"
                    (valueChange)="rangeChange($event)"
                ></mat-slider>
                <span class="range-value-text">
                    {{ getRangeDisplayText(control.value) }}
                </span>
            </div>
        </div>
        <!-- Standard validation errors -->
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
